module.exports = ".bio {\n  white-space: pre-line;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-detail/user-detail.component.css
// module id = ./src/app/user/user-detail/user-detail.component.css
// module chunks = main